module.exports = __webpack_public_path__ + "static/img/otoBg.e171132c.jpg";